// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__zkNrZ","formTitle":"Settings_formTitle__TonAF","button":"Settings_button__n7+S4"};